export default __webpack_public_path__ + "static/media/topic900_bg2.87b7a0cc.png";